import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useLocation } from 'react-router-dom';
import MetaComponent from '../components/MetaComponents/MetaComponent';
import PageHeading from '../components/ui/PageHeading';
import useMetaComponentDetails from '../hooks/useMetaComponentDetails';
import { fetchMetaList } from '../stores/meta-components/actions';
import { getFormattedPageHash } from '../utils';
import NotFound from './errors/NotFound';
import { getGlidePath } from '../helpers/glide-path';

let glidePath = getGlidePath();

glidePath =
  glidePath && glidePath.endsWith('/') ? glidePath.slice(0, -1) : glidePath;

const DynamicTitle = ({ endPoint }) => {
  const { metaData = {} } = useMetaComponentDetails(endPoint);
  const { title = '' } = metaData;

  return <PageHeading title={title} />;
};

const DynamicPage = () => {
  const dispatch = useDispatch();
  const { pathname = '' } = useLocation();
  const pageHash = getFormattedPageHash();
  const endPoint = `${glidePath}${pathname}`;
  const { isFetching = false, status } = useMetaComponentDetails(endPoint);
  const isSuccess = status === 'success' ? true : false;

  const { page: pageNo = 1 } = pageHash;

  const fetchList = async () => {
    try {
      await dispatch(fetchMetaList(endPoint, pageNo));
    } catch (e) {
      console.log(e);
    }
  };

  useEffect(() => {
    fetchList();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [endPoint]);

  return (
    <>
      {!isFetching && isSuccess ? (
        <div className="master__container dymaic-page">
          <DynamicTitle endPoint={endPoint} />
          <article className="page-master">
            <MetaComponent endPoint={endPoint} />
          </article>
        </div>
      ) : (
        ''
      )}

      {!isFetching && !isSuccess ? <NotFound /> : ''}
    </>
  );
};

export default DynamicPage;
